const testimonials = [
  {
    name: "Jennifer R.",
    location: "Celebration, FL",
    rating: 5,
    text: "My husband works at Disney and received a two-week notice for a training assignment at Disneyland Paris. We pulled his passport and discovered it had expired three months earlier. Fast Passport Center processed his renewal in five business days. He made the flight to Paris, completed his training, and even had time to visit the park with colleagues. Their team understood the urgency of Disney corporate travel better than any other service we contacted.",
    service: "Passport Renewal",
  },
  {
    name: "Michael and Sarah T.",
    location: "Celebration, FL",
    rating: 5,
    text: "We booked a Disney Cruise Line 7-night Caribbean cruise for our family of five — three kids ages 4, 7, and 10. I checked everyone's passports two weeks before sailing and found that all three kids' passports had expired. I panicked. Fast Passport Center walked us through the child passport process for all three children, we shipped everything overnight from the UPS Store in Kissimmee, and all five passports arrived four days later. We made the cruise with a day to spare. Absolutely saved our vacation.",
    service: "Child Passport",
  },
  {
    name: "Dr. Amanda L.",
    location: "Celebration, FL",
    rating: 5,
    text: "I am a cardiologist at AdventHealth Celebration and was invited to present at the European Society of Cardiology congress in Barcelona with four weeks' notice. My passport was valid but had only five months remaining — below the six-month requirement for Spain. Fast Passport Center processed my expedited renewal in six business days. I presented at the congress, networked with European colleagues, and returned with new collaborative research opportunities. Their service was professional, fast, and perfectly timed.",
    service: "Expedited Renewal",
  },
];

function Stars({ count }: { count: number }) {
  return (
    <div className="flex items-center gap-0.5">
      {Array.from({ length: count }).map((_, i) => (
        <i key={i} className="ri-star-fill text-[#F6C344] text-sm"></i>
      ))}
    </div>
  );
}

export default function CelebrationTestimonialsSection() {
  return (
    <section className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Reviews</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            What Celebration Travelers Say
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            Real reviews from Celebration Disney professionals, medical staff, and families who trusted Fast Passport Center with their expedited passports.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {testimonials.map((t, i) => (
            <div
              key={i}
              className="bg-white border border-gray-200 rounded-lg p-6 flex flex-col"
            >
              <Stars count={t.rating} />
              <p className="text-gray-600 text-sm leading-relaxed mt-4 flex-1 italic">
                &ldquo;{t.text}&rdquo;
              </p>
              <div className="mt-5 pt-4 border-t border-gray-200 flex items-center justify-between">
                <div>
                  <p className="font-bold text-[#1A365D] text-sm">{t.name}</p>
                  <p className="text-gray-400 text-xs">{t.location}</p>
                </div>
                <span className="text-xs font-semibold text-[#F6C344] bg-[#F6C344]/10 px-2.5 py-1 rounded-full whitespace-nowrap">
                  {t.service}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}